import * as actionTypes from '../../../actions/actiontypes';
import initialstate from '../../initialstate';
import {cloneDeep} from 'lodash';

export function aresLinkedDocumentsReducer(state = initialstate.aresLinkedDocuments, action) {
	switch (action.type) {
		case actionTypes.GET_LINKED_DOCUMENTS: {
			if (!action.error && action.response) {
				let newState = cloneDeep(state);
				if (state && Object.values(state).length > 0) {
					action.response.map((document) => {
						if (!state[document.id]) {
							newState = {
								...newState,
								[document.id]: document
							};
						}
					});
					return newState;
				}

				action.response.map((document) => {
					newState = {
						...newState,
						[document.id]: document
					};
				});
				return newState;
			}
			break;
		}
		default:
			return state;
	}
}
